import options from './thing-description.component';

export default {
    selector: 'dtThingDescription',
    options
};




// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-description/index.js